import { render, staticRenderFns } from "./groupacccf.vue?vue&type=template&id=094dd5f0"
import script from "./groupacccf.vue?vue&type=script&lang=js"
export * from "./groupacccf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports